import { render } from "./WorkspaceTabs.vue?vue&type=template&id=4829d2d8&ts=true"
import script from "./WorkspaceTabs.vue?vue&type=script&lang=ts"
export * from "./WorkspaceTabs.vue?vue&type=script&lang=ts"

import "./WorkspaceTabs.vue?vue&type=style&index=0&id=4829d2d8&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__